module.exports = __webpack_public_path__ + "img/25.de32db05.jpg";